import React from 'react'
import { injectIntl } from 'react-intl'
import { Input } from 'semantic-ui-react'

function FilterInput(props) {
    const { value, onChange, className, intl } = props
    const translates = {
        placeholder: intl.formatMessage({ id: 'filter.inputPlaceholder' })
    }

    return (
        <Input
            className={className}
            fluid
            onChange={(e, { sq, value }) => onChange(value)}
            value={value || ''}
            //placeholder={translates.placeholder}
        />
    )
}

export default injectIntl(FilterInput)